import { apiV3 } from './api';
import type {
  LibraryResponse,
  Section,
  SectionAssetsResponse,
  CreateSectionPayload,
  AssignSectionsPayload,
  AssetTagsResponse,
  AddTagPayload,
} from '@/types';

// ─── Library ──────────────────────────────────────────────────────────────────

export const sectionsService = {
  /** GET /api/v3/library?preview_limit=N — full browse grid for home screen */
  getLibrary: () =>
    apiV3.get<LibraryResponse>('/library', {
    //   params: { preview_limit: previewLimit },
    }),

  /** GET /api/v3/sections — flat list for sidebar / assign picker */
  getSections: () => apiV3.get<{ sections: Section[] }>('/sections'),

  /** POST /api/v3/sections — create a user_custom section */
  createSection: (payload: CreateSectionPayload) =>
    apiV3.post<Section>('/sections', payload),

  /** DELETE /api/v3/sections/{id} — only for user_custom sections */
  deleteSection: (id: string) => apiV3.delete(`/sections/${id}`),

  // ─── Section Assets ─────────────────────────────────────────────────────────

  /** GET /api/v3/sections/{id}/assets — paginated browse */
  getSectionAssets: (id: string, limit = 24, offset = 0) =>
    apiV3.get<SectionAssetsResponse>(`/sections/${id}/assets`, {
      params: { limit, offset },
    }),

  // ─── Asset → Section Assignment ─────────────────────────────────────────────

  /** POST /api/v3/assets/{asset_id}/sections — assign asset to sections */
  assignAssetToSections: (assetId: string, payload: AssignSectionsPayload) =>
    apiV3.post<{ assigned: number }>(`/assets/${assetId}/sections`, payload),

  /** DELETE /api/v3/assets/{asset_id}/sections/{section_id} — unpin asset */
  removeAssetFromSection: (assetId: string, sectionId: string) =>
    apiV3.delete(`/assets/${assetId}/sections/${sectionId}`),

  // ─── Tags ───────────────────────────────────────────────────────────────────

  /** GET /api/v3/assets/{asset_id}/tags */
  getAssetTags: (assetId: string) =>
    apiV3.get<AssetTagsResponse>(`/assets/${assetId}/tags`),

  /** POST /api/v3/assets/{asset_id}/tags — add / edit a tag */
  addAssetTag: (assetId: string, payload: AddTagPayload) =>
    apiV3.post<import('@/types').TagOverride>(`/assets/${assetId}/tags`, payload),

  /** DELETE /api/v3/assets/{asset_id}/tags/{tag_id} — soft-delete a tag */
  deleteAssetTag: (assetId: string, tagId: string) =>
    apiV3.delete(`/assets/${assetId}/tags/${tagId}`),
};
